module.exports = __webpack_public_path__ + "static/media/img3.77b73ed2.jpeg";